import { callAPI } from '../network';

export async function GetDataAbsenteeismSupport(employeeId, companyId, temporalId) {
    let url = `AbsenteeismSupport/GetDataAbsenteeismSupport?employeeId=${employeeId}&companyId=${companyId}`;
    
    if (temporalId !== null && temporalId !== undefined) {
        url += `&temporalId=${temporalId}`;
    }

    const data = await callAPI(null, url, 'get');
    return data;
}


export async function GetDataCodeCIE(searchTerm){

    const data = await callAPI(
                         null, 
                         `AbsenteeismSupport/GetDataCodeCIE?searchTerm=${searchTerm}`, 'get');
    return data;
}

export async function GetAllAbsenteeismIssuer(){

    const data = await callAPI(
                         null, 
                         `AbsenteeismSupport/GetAllAbsenteeismIssuer`, 'get');
    return data;
}

export async function GetAllDetailAbsenteeisms(){

    const data = await callAPI(
                         null, 
                         `AbsenteeismSupport/GetAllDetailAbsenteeisms`, 'get');
    return data;
}

export async function GetAllTypeAbsenteeisms(){

    const data = await callAPI(
                         null, 
                         `AbsenteeismSupport/GetAllTypeAbsenteeisms`, 'get');
    return data;
}

export async function GetAllDataAbsenteeismSupport(employeeId, companyId, temporalId){

    let url = `AbsenteeismSupport/GetAllDataAbsenteeismSupport?employeeId=${employeeId}&companyId=${companyId}`;
    
    if (temporalId !== null && temporalId !== undefined) {
        url += `&temporalId=${temporalId}`;
    }

    const data = await callAPI(null, url, 'get');
    return data;
}

export async function DeleteRegisterAbsenteeismSupport(id, employeeId){

    const data = await callAPI(
                         null, 
                         `AbsenteeismSupport/DeleteRegisterAbsenteeismSupport?id=${id}&employeeId=${employeeId}`, 'get');
    return data;
}

export async function SaveRegisterAbsenteeismSupport (data){
    const result = await callAPI(data, 'AbsenteeismSupport/SaveAbsenteeismSupport', 'post');
    return result;
}

export async function getAbsenteeismSupportConsult(params){
    const data = await callAPI(
                        null, 
                        `AbsenteeismSupport/GetAbsenteeismSupportConsult${params}`, 'get');
    return data || [];
}